// src/components/SnapshotTimeline.js
//
// Presentational component for the compact Snapshot page (ticket
// 032-snapshottimeline). Renders the "YOUR YEAR" card: an eyebrow, one intro
// sentence, and a numbered stepper of timeline nodes. All content comes
// pre-built from buildTimeline() in src/lib/buildSnapshotFindings.js — this
// component does no fact-reading or branching of its own, following
// SnapshotFinding.js's existing pattern exactly (pure props in, JSX out).
//
// New trc-* CSS namespace (D4) — not a reuse of .tr-panel or
// .triage-start-step-num; see plan.md D4 for why.

import React from 'react'

export default function SnapshotTimeline({ nodes, taxYear }) {
  return (
    <div className="trc-timeline-card">
      <div className="trc-timeline-eyebrow u-eyebrow">
        <span className="trc-timeline-eyebrow-icon" aria-hidden="true">📅</span>
        Your year
      </div>
      <p className="trc-timeline-intro">
        Here's how your {taxYear} filing obligations line up across the year.
      </p>
      <div className="trc-step-row">
        {nodes.map((node, i) => (
          <React.Fragment key={node.id}>
            {i > 0 && <div className="trc-step-connector" aria-hidden="true" />}
            <div className="trc-step">
              <div className="trc-step-num">{i + 1}</div>
              <div className="trc-step-title">{node.title}</div>
              {node.dateLabel && <div className="trc-step-date">{node.dateLabel}</div>}
            </div>
          </React.Fragment>
        ))}
      </div>
    </div>
  )
}
